import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
export const InterimTitle = styled.div `
    font-size: ${fontSizes.SUPER};
    font-weight: ${fontWeights.BOLD};
    padding-bottom: 16px;
`;
export const InterimBackground = styled.div `
    padding: 40px 16px;
    background-color: ${colors.black_8};
    margin: 40px 0;
    text-align: center;
`;
